import React, {useEffect, useRef, useState} from "react";
import {useAppDispatch, useAppSelector} from 'redux/hooks'
import {ProgressBar} from "primereact/progressbar";
import {classNames} from "primereact/utils";
import {Divider} from "primereact/divider";
import {checkPermissions} from "../../../../../redux/permissions/permissionsUtils";
import {setEditType} from "../../../../../redux/actions/actions";
import {setAudioDialogVisible, setAudioErrorField, setAudioField, setSelectedAudioIndex} from "../../../../../redux/actions/actionsAudio";
import {getAudioById, getTempUrlById} from "../../../../../redux/api/apiAudio";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import AudioPlayerComponent from "components/common/AudioPlayerWithSpeed";
import axios from "axios";
import {GET_AUDIO_URL_ID} from "../../../../../redux/types/typesAudioList";
import {SET_USER_STATUS_SUCCESS} from "../../../../../redux/types/typesUsersList";

const AudioListDetails = (props: any) => {
    const dispatch = useAppDispatch();
    const audioData = useAppSelector(state => state.AudioListReducer.audioData);
    const loader = useAppSelector(state => state.AudioListReducer.detailsLoading);
    const rolesVision = useAppSelector(state => state.RolesReducer.rolesVision) as unknown as Record<string, string[]>;
    const permissions = checkPermissions(rolesVision, 'Audio');
    const archiveTableToggle = useAppSelector(state => state.TrunksListReducer.archiveTrunkTableToggle);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);
    const [visible, setVisible] = useState(false);
    const audioPlayerRef = useRef<any>(null);
    const [playerKey] = useState<number>(0);
    const [visiblePlayerId, setVisiblePlayerId] = useState<number | null>(null);
    const [currentAudioSrc, setCurrentAudioSrc] = useState<string | null>(null);
    const [playRequested, setPlayRequested] = useState(false);
    const [lastRequestedAudioId, setLastRequestedAudioId] = useState<number | null>(null);
    const audioUrl = useAppSelector(state => state.AudioListReducer.audioUrlById);
    const loading = useAppSelector(state => state.AudioListReducer.audioUrlLoading);
    // @ts-ignore
    const branches = useAppSelector(state => state.UsersListReducer.branches);

    const {
        visible: hasAudioVisiblePermission,
        create: hasAudioCreatePermission,
        update: hasAudioUpdatePermission,
    } = permissions;

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleAudioReady = () => {
        if (audioPlayerRef.current) {
            audioPlayerRef.current.audio.current.pause();
        }
    };

    useEffect(() => {
        if (audioPlayerRef.current) {
            audioPlayerRef.current.audio.current.pause();
        }
    }, [audioData?.audioTempUrl])


    const audioHeaderBody = () => {
        return <p>{audioData?.audioName}</p>
    }

    const onFileUploadByLink = async () => {
        const responseUrl = await axios.get(`${audioData?.audioTempUrl}`, {
            responseType: 'blob',
            headers: {
                cache: 'no-store',
                'Cache-Control': 'no-cache'
            }
        });

        const blob = new Blob([responseUrl.data], {type: responseUrl.headers['content-type']});

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = url;
        link.setAttribute('download', `${audioData?.audioName}`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };

    const copyAudioLink = (url: string) => {
        if (!url || url.startsWith('blob:')) return;
        const copyToClipboard = (text: string) => {
            const tempElement = document.createElement('textarea');
            tempElement.value = text;
            document.body.appendChild(tempElement);
            tempElement.select();
            document.execCommand('copy');
            document.body.removeChild(tempElement);
        };
        copyToClipboard(url);
        dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: 'Посилання аудіо скопійована в буфер обміну'}});
    };

    const downloadAudioFromUrl = async (audioSrc: string, fileName: string) => {
        if (!audioSrc) return;
        if (audioSrc.startsWith('blob:')) {
            const link = document.createElement('a');
            link.href = audioSrc;
            link.setAttribute('download', fileName || 'audio.mp3');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            return;
        }
        const responseUrl = await axios.get(audioSrc, {
            responseType: 'blob',
            headers: { cache: 'no-store', 'Cache-Control': 'no-cache' }
        });
        const blob = new Blob([responseUrl.data], {type: responseUrl.headers['content-type']});
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName || 'audio.mp3');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };

    const audioBodyTemplate = () => {
        return hasAudioCreatePermission ? <>{(
            <div className="field col-12 md:col-12 flex align-items-center mb-0 px-0">
                <Button icon="pi pi-caret-right" onClick={() => {
                    // handlePlay();
                    setVisible(true);
                }} className="bg-primary" label="Прослухати"/>
            </div>)}
            <Dialog header={audioHeaderBody} visible={visible} style={{width: '25vw'}} className="pb-0 audio-dialog" onHide={() => setVisible(false)}>
                {audioData?.audioTempUrl && <div className="field col-12 md:col-12 flex flex-column align-items-center relative mt-2">
                    <div className="w-full relative">
                        <AudioPlayerComponent
                            key={playerKey}
                            ref={audioPlayerRef}
                            className="audio-player border-round-sm mt-3"
                            autoPlay={false}
                            onCanPlay={handleAudioReady}
                            src={audioData?.audioTempUrl || null}
                            style={{backgroundColor: 'rgba(255, 255, 255, 0.05)'}}
                        />
                        {hasAudioUpdatePermission && (
                            <Button
                                icon="pi pi-download"
                                onClick={onFileUploadByLink}
                                style={{marginLeft: '10px'}}
                                className={`absolute outline-none border-none shadow-none border-circle save-mp3 text-lg ${audioPlayerRef ? 'opacity-100' : 'opacity-50'}`}
                            />
                        )}
                        {hasAudioCreatePermission && (
                            <Button
                                icon="pi pi-copy"
                                onClick={() => copyAudioLink(audioData?.audioTempUrl)}
                                disabled={!audioData?.audioTempUrl || audioData?.audioTempUrl?.startsWith?.('blob:')}
                                style={{marginLeft: '10px'}}
                                className={`absolute outline-none border-none shadow-none border-circle save-mp3 text-lg ml-6 ${audioData?.audioTempUrl ? 'opacity-100' : 'opacity-50'}`}
                            />
                        )}
                    </div>
                </div>}
            </Dialog>
        </> : ''
    }

    const fields = [
        {label: "ID", value: audioData?.groupId},
        {label: "Стан", value: audioData?.isActive ? 'Активна' : 'Не активна'},
        {label: "Назва аудіо:", value: audioData?.audioFileName || '- - -'},
        {label: "Опис", value: audioData?.description || '- - -'},
    ];

    const openEditor = () => {
        dispatch(setSelectedAudioIndex(audioData?.groupId || props.selectedRowData));
        dispatch(setAudioDialogVisible(true));
        dispatch(setAudioErrorField(null));
        dispatch(getAudioById(props.selectedRowData, jwtToken?.jwtToken));
        if (hasAudioUpdatePermission) {
            dispatch(setEditType(true));
        } else {
            dispatch(setEditType(false));
        }
    }

    const handlePlayAudio = async (audio: any) => {
        setPlayRequested(true);
        setLastRequestedAudioId(audio.audioId);

        if (audio.audioTempUrl) {
            setCurrentAudioSrc(audio.audioTempUrl);
            setVisiblePlayerId(audio.audioId);
            setPlayRequested(false);
            return;
        }

        dispatch(getTempUrlById(audio?.audioId, jwtToken?.jwtToken));
    };

    useEffect(() => {
        if (playRequested && audioUrl?.tempUrl && lastRequestedAudioId) {
            const requestedAudio = audioData?.audios?.find((a: any) => a.audioId === lastRequestedAudioId);
            const isMatch = audioUrl?.audioId === lastRequestedAudioId ||
                           audioUrl?.fileName === requestedAudio?.audioFileName;

            if (isMatch) {
                setCurrentAudioSrc(audioUrl.tempUrl);
                // Обновляем audioTempUrl только если его еще нет, чтобы избежать бесконечного цикла
                if (requestedAudio && !requestedAudio.audioTempUrl) {
                    const updatedAudios = audioData?.audios?.map((audio: any) => {
                        if (audio.audioId === lastRequestedAudioId) {
                            return { ...audio, audioTempUrl: audioUrl.tempUrl };
                        }
                        return audio;
                    });
                    if (updatedAudios) {
                        dispatch(setAudioField({
                            section: 'audioData',
                            fieldName: 'audios',
                            value: updatedAudios
                        }));
                    }
                }
                setVisiblePlayerId(lastRequestedAudioId);
                setPlayRequested(false);
            }
        }
        // Убираем audioData?.audios из зависимостей, чтобы избежать бесконечного цикла
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [audioUrl, playRequested, lastRequestedAudioId, dispatch]);

    const audioItems = audioData?.audios?.map((audio: any, index: number) => {
        const isCurrentAudio = visiblePlayerId === audio.audioId;
        const audioSrc = isCurrentAudio ? currentAudioSrc : audio.audioTempUrl;
        const isLoading = loading && lastRequestedAudioId === audio.audioId;

        return (
            <div className="grid m-0 mb-2 align-items-center" key={index}>
                {/* 1 колонка — ID */}
                <div className="col-12 md:col-2">
                    <p className="font-semibold mb-0">
                        {audio.groupId || audio.audioId}
                    </p>
                </div>

                {/* 2 колонка — название */}
                <div className="col-12 md:col-6">
                    <p className="mb-0 text-overflow-ellipsis overflow-hidden white-space-nowrap">
                        {audio.audioName}
                    </p>
                </div>

                {/* 3 колонка — кнопка + диалог */}
                <div className="col-12 md:col-4 flex align-items-center">
                    {hasAudioCreatePermission && (
                        <Button
                            label="Прослухати"
                            icon="pi pi-play"
                            className="mr-3"
                            loading={isLoading}
                            onClick={() => handlePlayAudio(audio)}
                        />
                    )}

                    {isCurrentAudio && audioSrc && (
                        <Dialog
                            header={audio.audioName}
                            visible={isCurrentAudio}
                            style={{ width: '25vw', minWidth: '300px' }}
                            className="pb-0 audio-dialog"
                            onHide={() => {
                                setVisiblePlayerId(null);
                                setCurrentAudioSrc(null);
                            }}
                        >
                            <div className="field col-12 mt-2">
                                <div className="w-full relative">
                                    <AudioPlayerComponent
                                        key={`player-${audio.audioId}`}
                                        className="w-full audio-player border-round-sm border-none mt-3"
                                        autoPlay={false}
                                        src={audioSrc}
                                        style={{
                                            backgroundColor: 'rgba(255, 255, 255, 0.05)',
                                        }}
                                    />
                                    {hasAudioCreatePermission && (
                                        <>
                                            <Button
                                                icon="pi pi-download"
                                                onClick={() => downloadAudioFromUrl(audioSrc, audio.audioName || audio.audioFileName || 'audio.mp3')}
                                                style={{marginLeft: '10px'}}
                                                className="absolute outline-none border-none shadow-none border-circle save-mp3 text-lg opacity-100"
                                            />
                                            <Button
                                                icon="pi pi-copy"
                                                onClick={() => copyAudioLink(audioSrc)}
                                                disabled={audioSrc.startsWith('blob:')}
                                                style={{marginLeft: '10px'}}
                                                className="absolute outline-none border-none shadow-none border-circle save-mp3 text-lg ml-6 opacity-100"
                                            />
                                        </>
                                    )}
                                </div>
                            </div>
                        </Dialog>
                    )}
                </div>
            </div>
        )
    })

    const formattedBranches = branches?.map((branch: { id: any; name: any; }) => ({
        ...branch,
        label: `${branch.id} ${branch.name}`,
    }));

    const branchItems = audioData?.audioGroupBranches?.map((queueItem: any, index: number) => {
        return formattedBranches?.map((branchItem: any) => {
            if (queueItem.id === branchItem.id) {
                return (
                    <div className="field col-12 md:col-10 flex m-0 border-round-sm pl-0" key={index}>
                        {branchItem.label}
                    </div>
                )
            }
        })
    })

    return (
        <div className="">
            <div className="relative">
                {loader && <ProgressBar mode="indeterminate" style={{height: '6px'}}></ProgressBar>}
                <div className={classNames('grid', {'opacity-50': loader})} style={{paddingTop: "0.3rem", padding: '0.3rem 10px 5px'}}>
                    {windowWidth > 1248 && <div className="grid col-12 md:col-12 mb-0 flex justify-content-between">
                        <div className="field col-12 md:col-6 flex align-items-center flex-wrap m-0">
                            <div className="field col-12 md:col-4 flex align-items-center m-0 p-0">
                                <p className="w-full">ID: {audioData?.groupId}</p>
                            </div>
                            <div className="field col-12 md:col-8 flex align-items-center m-0 p-0">
                                {(audioData?.isHold || audioData?.isRingback) && <p className="w-full">По замовчуванню для:</p>}
                            </div>
                            <div className="field col-12 md:col-4 flex align-items-center m-0 p-0">
                                <p className="w-full">{audioData?.groupName}</p>
                            </div>
                            <div className="field col-12 md:col-8 flex align-items-center m-0 p-0">
                                <div className="flex flex-column">
                                    {audioData?.isHold && <p className="mb-0">HOLD</p>}
                                    {audioData?.isRingback && <p>RINGBACK</p>}
                                </div>
                            </div>
                        </div>
                        <div className="col-12 md:col-5 flex align-items-center m-0 p-0 justify-content-end text-right">
                            <div className="field col-12 md:col-5 flex align-items-center justify-content-end m-0 p-0">
                                {/*<p className="w-full">Приоритет: {audio?.priority || '0'}</p>*/}
                            </div>
                            <div className="field col-12 md:col-5 flex align-items-center justify-content-end m-0 p-0">
                                <p className="w-full">{audioData?.isActive ? 'Активна' : 'Не активна'}</p>
                            </div>
                            <div className="field col-12 md:col-2 flex align-items-center m-0 p-0">
                                <button className="close-button block cursor-pointer mr-1" onClick={() => {
                                    openEditor();
                                }}><span className={classNames('', {
                                    'pi pi-pencil': archiveTableToggle && hasAudioUpdatePermission,
                                    'pi pi-eye': !archiveTableToggle || !hasAudioUpdatePermission
                                })}></span></button>
                                <button className="close-button block cursor-pointer ml-0" onClick={() => {
                                    props.setSelectedRowData(null);
                                    dispatch(setAudioField({section: 'audioData', fieldName: 'audioTempUrl', value: null}));
                                }}><span className="pi pi-times"></span></button>
                            </div>
                        </div>
                    </div>}
                    {windowWidth <= 1248 && <div className="grid col-12 md:col-12 mb-0 px-0">
                        <div className="field col-12 md:col-12 flex align-items-center m-0">
                            <p className="w-full">{audioData?.groupName}</p>
                        </div>
                        {(<div className="field col-12 md:col-12 p-0" style={{margin: 0, borderBottom: '1px solid #cccccc38'}}></div>)}
                    </div>}
                    {windowWidth <= 1248 && <>
                        {fields.map((field: any) => (
                            <React.Fragment key={field.label}>
                                <div className="field col-4 md:col-6 flex align-items-start m-0">
                                    <p>{field.label}</p>
                                </div>
                                <div className="field col-8 md:col-6 flex align-items-start m-0">
                                    <p>{field.value}</p>
                                </div>
                            </React.Fragment>
                        ))}
                        {windowWidth <= 1248 && <div className="field col-12 md:col-12 flex-column flex-wrap mb-0 px-0">
                            <div className="field col-12 md:col-12 flex align-items-start m-0">
                                <p>Група аудіо:</p>
                            </div>
                            {audioItems || '- - -'}
                        </div>}
                    </>}
                    {windowWidth > 1248 &&
                        <React.Fragment>
                            <Divider className="my-0"/>
                            <div className="field col-12 md:col-12 flex align-items-center m-0">

                                <div className="field col-12 md:col-6 flex align-items-center m-0 p-0">
                                    <p className="w-full">Група аудіо:</p>
                                </div>
                                {hasAudioVisiblePermission && <div className="field col-12 md:col-4 flex align-items-center m-0 p-0">
                                    <p className="w-full">Бранч</p>
                                </div>}
                                <div className="field col-12 md:col-2 flex align-items-center m-0 p-0">
                                    <p className="w-full">Опис</p>
                                </div>
                            </div>
                            <Divider className="my-0"/>
                            <div className="field col-12 md:col-12 flex m-0 scroll-detail-items">
                                <div className="field col-12 md:col-6 flex flex-column m-0 p-0">
                                    {/*{audioData?.audioFileName || '- - -'}*/}
                                    {audioItems || '- - -'}
                                </div>
                                <div className="field col-12 md:col-4 flex m-0 p-0 flex-wrap flex-column">
                                    {branchItems}
                                </div>
                                <div className="field col-12 md:col-2 flex m-0 p-0">
                                    {audioData?.description || '- - -'}
                                </div>
                            </div>
                        </React.Fragment>
                    }
                </div>
            </div>
        </div>
    )
}

export default AudioListDetails;
